export default [
     {
          Id: "1",
          Name: "React (Basic)",
          Organizer: "Hackerrank",
          Path: "https://user-images.githubusercontent.com/109352268/221853327-0316d66a-9fa7-43ca-8bbc-d126a2e8e7de.png",
          Link: "https://www.hackerrank.com/certificates/d0ff81b7027a",
     },
     {
          Id: "2",
          Name: "Javascript (Basic)",
          Organizer: "Hackerrank",
          Path: "https://user-images.githubusercontent.com/109352268/221852822-ee491053-fb1d-49e8-9793-11ea66956951.png",
          Link: "https://www.hackerrank.com/certificates/9f46f5956fba",
     },
     {
          Id: "3",
          Name: "Javascript (Intermediate)",
          Organizer: "Hackerrank",
          Path: "https://user-images.githubusercontent.com/109352268/221853453-8044fab5-5c6e-4a44-b792-0bdac6910f94.png",
          Link: "https://www.hackerrank.com/certificates/6eee01216f64",
     },

     {
          Id: "4",
          Name: "Restapi (Intermediate)",
          Organizer: "Hackerrank",
          Path: "https://user-images.githubusercontent.com/109352268/221853205-c2e10524-8101-4475-8fa8-a4661b39e8c6.png",
          Link: "https://www.hackerrank.com/certificates/28a10eafe7f9",
     },
     {
          Id: "5",
          Name: "Problem Solving (Basic)",
          Organizer: "Hackerrank",
          Path: "https://user-images.githubusercontent.com/109352268/221853442-eee935c8-72f3-4213-9f9c-8361573576fc.png",
          Link: "https://www.hackerrank.com/certificates/6be2f15950f3",
     },
     {
          Id: "6",
          Name: "Dsa-Advanced",
          Organizer: "Cutshort",
          Path: "https://user-images.githubusercontent.com/109352268/221858612-08fa8d02-d4dc-4bd6-bc73-e0c374463072.png",
          Link: "https://cutshort.io/certificate/78739",
     },
     {
          Id: "7",
          Name: "Javascript-Advanced",
          Organizer: "Cutshort",
          Path: "https://user-images.githubusercontent.com/109352268/221858622-03bedfa0-f9e2-4c14-9876-db3f244423be.png",
          Link: "https://cutshort.io/certificate/78736",
     },
     {
          Id: "8",
          Name: "Javascript-Algorithm",
          Organizer: "FreeCodeCamp",
          Path: "https://user-images.githubusercontent.com/109352268/221860366-2fbc4014-639d-4e7a-9acf-7751cb95cfc8.png",
          Link: "https://freecodecamp.org/certification/fccd23ab33c-ca4c-4fee-9278-8410a35e3824/javascript-algorithms-and-data-structures",
     },
     {
          Id: "9",
          Name: "Javascript-Course",
          Organizer: "Udemy",
          Path: "https://user-images.githubusercontent.com/109352268/221861086-7aba48b8-21ec-464f-8c84-c041573d2fa6.jpg",
          Link: "https://www.udemy.com/certificate/UC-a82d2962-a795-450e-a338-c0447b83327e/",
     },
     {
          Id: "10",
          Name: "Tripalebyte",
          Organizer: "Triplebyte",
          Path: "https://user-images.githubusercontent.com/109352268/222217976-69cb2cf8-291d-4072-940a-600152c34c36.png",
          Link: "https://triplebyte.com/tb/richhapal-choudhary-eitwh6v/certificate",
     },
];
